import { createContext, useContext } from "react";

import type { State, Toast, TrayState } from "./types";

export type ImportToasterContextValues = {
  state: State;
  trayState: TrayState;

  toasts: Toast[];

  setToasts: (toasts: Omit<Toast, "id">[]) => void;
  dismissToast: (id: Toast["id"]) => void;

  show: () => void;
  hide: () => void;

  openTray: () => void;
  closeTray: () => void;
  toggleTray: () => void;
};

export const ImportToasterContext = createContext<ImportToasterContextValues>({
  state: "hidden",
  trayState: "closed",

  toasts: [],

  setToasts: () => {},
  dismissToast: () => {},

  show: () => {},
  hide: () => {},

  openTray: () => {},
  closeTray: () => {},
  toggleTray: () => {},
});

export const useImportToaster = (): ImportToasterContextValues => useContext(ImportToasterContext);
